export default {
  getColunas(state) {
    return state.colunasDisponiveis;
  },
  getColunasDisponiveis(state) {
    return state.colunasDisponiveis.filter((coluna) => coluna.noExport !== true);
  },
  getColunasData(state) {
    return state.colunasDisponiveis.filter((coluna) => coluna.type === 'date');
  },
  getProcessos(state) {
    return state.processes || [];
  },
  getProcessosFiltrar(state) {
    return state.processosFiltrar || [];
  },
  getPaginacao(state) {
    if (state.processPages) {
      return state.processPages;
    }

    return {
      from: 0,
      to: 0,
      current_page: 1,
      next_page: null,
      prev_page: null,
      per_page: 20,
      last_page: 1,
      total: 0,
    };
  },
  getTotalProcessosPorStatus(state) {
    return state.totalProcessesByStatus;
  },
  getFiltroMapaStatus(state) {
    return state.filtroMapaStatus;
  },
  getProcessoSelecionado(state) {
    if (Array.isArray(state.selectedProcess) && state.selectedProcess.length === 1) {
      return state.selectedProcess[0];
    }
    return null;
  },
  getLinkProcesso(state) {
    if (!state.selectedProcess.length) {
      return '';
    }
    const URL_BASE = process.env.VUE_APP_FRONTEND_HOST_PORT;
    const { PRI_COD, FIL_COD } = state.selectedProcess[0];
    if (!(PRI_COD && FIL_COD)) {
      return '';
    }
    return `${URL_BASE}/processos/kanban?processo=${PRI_COD}&filial=${FIL_COD}`;
  },
  getEmTempoAtrasados(state) {
    return state.emTempoAtrasados;
  },
  getFiltros(state) {
    return state.filtros;
  },
  getCampos(state) {
    return state.campos;
  },
  getColDefault(state) {
    return state.colDefault;
  },
  getDirectionDefault(state) {
    return state.directionDefault;
  },
  getDateCols(state) {
    return state.dateCols;
  },
  getRenderCols(state) {
    return state.renderCols;
  },
  getSelectedObject(state) {
    return state.objectSelected;
  },
  getSelectProcess(state) {
    return state.selectedProcess[0];
  },
  getDocumentosProcessoSelecionado(state) {
    return state.documentosProcessoSelecionado;
  },
  getResetKanbanFilters(state) {
    return state.resetKanbanFilters;
  },
};
